import { jsx as _jsx } from "react/jsx-runtime";
import { CardTitle } from '@airtel/air-design-system';
function InfoListHeader(props) {
  var _props$headerElementP = props.headerElementProps,
    headerElementProps = _props$headerElementP === void 0 ? {} : _props$headerElementP,
    id = props.id,
    onUserAction = props.onUserAction,
    testID = props.testID;
  var _headerElementProps$o = headerElementProps.onHeaderActionPressMetaData,
    onHeaderActionPressMetaData = _headerElementProps$o === void 0 ? {} : _headerElementProps$o,
    _headerElementProps$o2 = headerElementProps.onToolTipPressMetaData,
    onToolTipPressMetaData = _headerElementProps$o2 === void 0 ? {} : _headerElementProps$o2;
  return !!headerElementProps && _jsx(CardTitle, Object.assign({
    testID: testID
  }, headerElementProps, {
    infoIconPress: () => onToolTipPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onToolTipPressMetaData), {
      id,
      headerElementProps
    })),
    onActionIconPress: () => {
      onHeaderActionPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onHeaderActionPressMetaData), {
        id,
        headerElementProps
      }));
    },
    actionCtaOnPress: () => {
      onHeaderActionPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onHeaderActionPressMetaData), {
        id,
        headerElementProps
      }));
    }
  }));
}
export default InfoListHeader;